import config from '../config/app'
import axios from 'axios'
import Helper from '../helper/helper'
import store from '../store'

const PATH = 'project'
const VERSION = '/v2/'

const projectAPI = {
  /**
  * get all active projects
  */
  newGetProjects (params, additional, urlFilters = null, user = null) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    if (urlFilters !== null && urlFilters !== undefined) {
      stringParams = stringParams + '&' + urlFilters
    }
    let url = ''
    if (user) {
      url = config.server + VERSION + PATH + '?' + stringParams
    } else {
      url = config.server + VERSION + 'guest/' + PATH + '?' + stringParams
    }

    return new Promise((resolve, reject) => {
      axios.post(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },

  /**
   * get all active projects
   */
  getSimilarProjects (id, params, additional, urlFilters = null, user = null) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    if (urlFilters !== null && urlFilters !== undefined) {
      stringParams = stringParams + '&' + urlFilters
    }
    let url = ''
    if (user) {
      url = config.server + VERSION + PATH + '/similar/' + id + '?' + stringParams
    } else {
      url = config.server + VERSION + 'guest/' + PATH + '/similar/' + id + '?' + stringParams
    }
    return new Promise((resolve, reject) => {
      axios.post(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getProjectChangelog (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => {
      return params[i] !== '' && params[i] !== null
    }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => {
        return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m])
      }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + VERSION + 'project/change-log?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getProjectIds () {
    let url = config.server + VERSION + 'project/get-project-ids?'
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  /** =================================================
   * get all user projects
   *
   * @param userId
   * @param additionalFields
   * @param filters
   * @returns {*|Promise}
   */
  getByUserId (userId, additionalFields, filters) {
    if (filters !== undefined) {
      filters.user_id = userId
    } else {
      filters = {user_id: userId}
    }
    return this.get(filters, additionalFields)
  },

  /**
   * get project by ID
   *
   * @param projectId
   * @param additionalFields
   * @returns {*|Promise}
   */
  getById (projectId, additionalFields) {
    return new Promise((resolve, reject) => {
      this.get({id: projectId}, additionalFields).then((response) => {
        resolve(response[0])
      }, (error) => {
        reject(error)
      })
    })
  },
  // getContributionProjectCount (params, additional) {
  //   if (additional !== null && additional !== undefined) {
  //     params.additional = additional.join(',')
  //   }
  //   let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
  //     return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
  //   }).join('&')
  //   let url = config.server + '/v2/project/get-contribution-project-count?' + stringParams
  //   return new Promise((resolve, reject) => {
  //     axios.get(url).then((response) => {
  //       resolve(response.data)
  //     }, (error) => {
  //       reject(error)
  //     })
  //   })
  // },
  getContributionTopProject (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/v2/project/get-contribution-top-project?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getNumberOfGiving (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/v2/project/get-numbers-of-giving?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getLiveByUserId (userId, additional) {
    return this.getByUserId(userId, additional, {status: 'live', project_approved: 1})
  },
  getLive (additionalFields, urlFilters = null) {
    return this.get({status: 'live'}, additionalFields, urlFilters)
  },
  favProject (userId, projectId, isCompany, type = '', pageTitle = '') {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/project/favorite', {
        user_id: userId,
        project_id: projectId,
        is_company: isCompany,
        type: type
      }).then((response) => {
        resolve(response.data)
        console.log('===========user 111111=======================')
        console.log(store.getters.currentUser)
        if (store.getters.currentUser !== null) {
          if (store.getters.currentUser.register_source === 'trial-online') {
            console.log('===========finalsss=======================')
            window.gtag('event', 'TRIAL6 Favourited Projects', {
              event_category: 'TRIAL6_Favourited_Projects',
              event_label: 'TRIAL6_Favourited_Projects',
              value: 'Yes'
            })
          }
        }
      }, (error) => {
        reject(error)
      })
    })
  },
  search (key, additional) {
    return this.get({status: 'live', project_approved: 1, search: key}, additional)
  },
  getProjects (additionalFields, filters, urlFilters = null) {
    return this.get(filters, additionalFields, urlFilters)
  },
  getProjectsNew (additionalFields, filters, urlFilters = null) {
    return this.getNew(filters, additionalFields, urlFilters)
  },
  getFavProjects (userId, additionalFields, filters) {
    let query = additionalFields !== undefined ? '&additional=' + additionalFields.join(',') : ''
    let str = ''
    if (filters !== undefined) {
      str = Object.keys(filters).map(function (key) {
        return key + '=' + filters[key]
      }).join('&')
    }
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/project/favorite?user_id=' + userId + '&' + query + '&' + str).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  update (projectId, data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/project/' + projectId,
        mimeType: 'multipart/form-data',
        data: Helper.getFormData(data)
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  save (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/project',
        mimeType: 'multipart/form-data',
        data: Helper.getFormData(data)
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  remove (projectId, data = {}) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/project/' + projectId, {data: data}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  /**
   * Base method for get projects
   *
   * @param params
   * @param additional
   * @param urlFilters
   * @returns {Promise}
   */
  get (params, additional, urlFilters = null) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }

    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')

    if (urlFilters !== null && urlFilters !== undefined) {
      stringParams = stringParams + '&' + urlFilters
    }
    let url = config.server + '/project?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getNew (params, additional, urlFilters = null) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }

    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')

    if (urlFilters !== null && urlFilters !== undefined) {
      stringParams = stringParams + '&' + urlFilters
    }
    let url = config.server + '/project/filter?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  commonImpactDataFilter (impacts) {
    return impacts.filter(item => item.status === 'active')
  },
  getValidProject (projectId) { // Check Project status active or not
    let url = config.server + '/project/valid-project?id=' + projectId
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  removeProjectMedia (data) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/project/media', {data: data}).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  getChristmasBundle (data) {
    let url = config.server + '/getChristmasBundle'
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateStatus (projectId, data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/project/' + projectId + '/status/update', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getGlobalProjects () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/project/globalProject').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  loadProjectConditionData (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/project/get-project-country-and-list', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  loadProjectFromCountry (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/project/get-project-from-country', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  createProjectListingCondition (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/project/create-project-listing-condition', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}
export default projectAPI



// WEBPACK FOOTER //
// ./src/api/project.js